import { useState, useRef } from 'react'
import { ModalProvider } from '@commons/enhanced-modal/ModalContext'
import { PbPropsProvider } from '@content/helpers/src/context'
import { getPBProps } from '@content/helpers/src/utils.ts'
import styles from './FeaturedContent.module.scss'
import { PBProps } from './types'

import ContentSlider from './components/contentSlider/ContentSlider'
import SectionHeader from '@commons/section-header/SectionHeader'
import ModalRenderer from '@commons/enhanced-modal/ModalRenderer'

type FeaturedContentProps = {
    data: string
}

const FeaturedContent = ({ data }: FeaturedContentProps) => {
    const pbProps = getPBProps<PBProps>(data)
    const { copywriting, layout, campaign } = pbProps as PBProps
    const layoutPadding = [layout.padding_top, layout.padding_bottom]
    const containerRef = useRef(null)

    const [selectedPromotionDetails, setSelectedPromotionDetails] =
        useState(null)

    return (
        <div
            ref={containerRef}
            className={`${[...layoutPadding].join(' ')} ${styles.featuredContent}`}>
            <PbPropsProvider value={pbProps}>
                <ModalProvider>
                    <ModalRenderer
                        promotion_details={selectedPromotionDetails}
                        campaign={campaign}
                    />

                    <header className={styles.featuredProductsHeader}>
                        <SectionHeader
                            headline={copywriting.heading}
                            subhead={copywriting.sub_heading}
                            description={copywriting.description}
                            alignMobile="left"
                            headlineTag="h2"
                        />
                    </header>
                    <ContentSlider
                        setSelectedPromotionDetails={
                            setSelectedPromotionDetails
                        }
                    />
                </ModalProvider>
            </PbPropsProvider>
        </div>
    )
}

export default FeaturedContent
